import { extendTheme } from '@chakra-ui/react';
import { FONT_FAMILY } from '@/constants/default-props';
import {  BG_COLOR, TEXT_COLOR } from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body_lv2: FONT_FAMILY.body_lv2,
    body: FONT_FAMILY.body,
    // hardcoded font family for qrcode purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '48px',
    subHeading: '38px',
    body: '18px',
    body_lv2: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    body_lv2: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
      },
    },
  },
  colors: {
    bgPrimary: BG_COLOR.primary,
    bgSecondary: BG_COLOR.secondary,
    bgAlternative: BG_COLOR.alternative,
    mainColorText: TEXT_COLOR.primary,
    secondaryColorText: TEXT_COLOR.secondary,
    alternativeColorText: TEXT_COLOR.alternative,
    transparent: 'transparent',
  },
};

export default extendTheme(theme);
